import React from 'react';
import PropTypes from 'prop-types';

import OrderDetailsShipmentEvent from './OrderDetailsShipmentEvent';

const OrderDetailsShipments = ({ expandAll, orderDetailsData: { shippingInformation } }) =>
  shippingInformation && shippingInformation.length > 0 ? (
    <div className='orderDetails__shipments'>
      {shippingInformation.map((info, i) => (
        <OrderDetailsShipmentEvent
          key={info.deliveryNotes.createTimestamp}
          receivedExpand={expandAll}
          shipmentNumber={i + 1}
          shipmentsTotal={shippingInformation.length}
          shipmentInfo={info}
        />
      ))}
    </div>
  ) : null;

OrderDetailsShipments.propTypes = {
  expandAll: PropTypes.bool.isRequired,
  orderDetailsData: PropTypes.object.isRequired
};

export default OrderDetailsShipments;
